import ModalWrap from '../../components/common/modal-wrap';
import { CloseCrossBtn } from '../../components/icons/close-cross-btn';

export interface IJournalModalPanel {
  isShow: boolean;
  onClick: () => void;
  children?: React.ReactNode;
}

export const JournalModalPanel = ({ isShow, onClick, children }: IJournalModalPanel) => {
  return (
    <ModalWrap isShow={isShow}>
      <div className="w-[980px] max-w-[90vw] rounded-[20px] lg:rounded-[40px] p-5 lg:p-8 bg-white relative">
        <div className="absolute top-[20px] lg:top-[40px] right-[20px] lg:right-[40px]" onClick={onClick}>
          <CloseCrossBtn />
        </div>
        {children}
      </div>
    </ModalWrap>
  );
};
